import React from 'react';
import './Towcol.css';

const services = [
  {
    id: 'soluciones',
    icon: 'fas fa-cloud',
    title: 'Soluciones en la nube',
    description: 'Aprovechamos el poder de la plataforma virtual para optimizar la operación de su empresa.'
  },
  {
    id: 'office365',
    icon: 'fas fa-briefcase',
    title: 'Office 365',
    description: 'Implementamos Microsoft 365 con mejores prácticas de productividad y gobierno de la información.'
  },
  {
    id: 'analisis',
    icon: 'fas fa-shield-alt',
    title: 'Análisis de Seguridad',
    description: 'Evaluamos riesgos y fortalecemos la ciberseguridad con protección multicapa y monitoreo continuo.'
  },
  {
    id: 'software',
    icon: 'fas fa-chart-line',
    title: 'Software financiero',
    description: 'Integramos soluciones de factoring, contabilidad y planilla adaptadas a los procesos de su negocio.'
  }
];

function Towcol() {
  return (
    <section className='company-overview'>
      <div className='services-grid'>
        {services.map((service) => (
          <article key={service.id} id={service.id} className='service-card'>
            <span className={`service-icon ${service.icon}`} aria-hidden='true'></span>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </article>
        ))}
      </div>

      <div className='certifications'>
        <img src='/images/salespro-400x400-1.png' alt='Acronis Professional Cloud Tech badge' />
        <img
          src='/images/thumb-ES_-_545_Partner_SM_Banners_4.gif'
          alt='Especialista brindando soporte tecnológico'
          className='certification-illustration'
        />
        <img src='/images/Profesional-400x400-1.png' alt='Acronis Professional Cloud Sales badge' />
      </div>
    </section>
  );
}

export default Towcol;
